import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let token = JSON.parse(localStorage.getItem("token"));

    let headers = {
        Authorization: `Bearer ${token}`,
    };

    // If data is NOT FormData, set Content-Type to application/json
    if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const requestOptions = {
        method: method,
        headers: headers,
        body: data instanceof FormData ? data : JSON.stringify(data)
    };

    return requestOptions;
};
// api
export const profileApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}profile?tab=${payload?.tab}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const updateProfile = async (payload) => {
    const request = requestAuthOption("PUT", payload)
    try {
        const response = await fetch(`${server}profile/update`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "update_success" || data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const createSalesmanApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(`${server}profile/salesman`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const deleteSalesmanApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(`${server}profile/salesman/${payload.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const setDefaultSalesmanApi = async (payload) => {
    const request = requestAuthOption("PUT")
    try {
        const response = await fetch(`${server}profile/salesman/${payload.id}/default`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const deleteTeamMemberApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(`${server}profile/team-member/${payload.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const addTeamMemberApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(`${server}profile/team-member/invite`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    } else if(data?.code ==='error'){
                        resolve(data);
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const reinviteTeamMemberApi = async (payload) => {
    const request = requestAuthOption("POST", payload.data)
    try {
        const response = await fetch(`${server}profile/team-member/reinvite/${payload.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    } else if(data?.code ==='error'){
                        resolve(data);
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const removeInvitationTeamMemberApi = async (payload) => {
    const request = requestAuthOption("POST", payload.data)
    try {
        const response = await fetch(`${server}profile/team-member/remove-invite/${payload.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    } else if(data?.code ==='error'){
                        resolve(data);
                    }
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};